<script setup lang="ts">
defineProps<{
    title: string;
    description: string;
}>();
</script>

<template>
  <div class="flex bg-white border-[1.5px] border-primary hover:border-primary/50 hover:opacity-75 py-4 px-3 rounded-lg">
    <div v-if="$slots['icon']" class="mr-1">
      <slot name="icon" />
    </div>
    <h3>{{ title }}</h3>
    <p class="text-primary flex-1">
      &nbsp;- {{ description }}
    </p>
    <p class="text-primary">
      Accéder au menu
    </p>
  </div>
</template>
